// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3jq44","content":"Consent_content__2K3kg","footer":"Consent_footer__2_AGZ"};